import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { debounce } from './helpers/searchHelper';
// import  { MediaQuery } from 'react-responsive';
import MediaQuery from 'react-responsive';
// import styled from 'styled-components'

// import MediaQuery from
// STYLE ZOALS DEZE https://www.twilio.com/


const styles = {
  ulStyle: {
    fontSize: '1.5em',
    boxSizing: 'border-box',
    listStyleType: 'none',
    margin: '0',
    padding: '0',
    overflow: 'hidden',
    position: 'fixed',
    top: '0',
    width: '100%',
    // borderBottom: '1px solid lightgrey',
    zIndex: '60',
    backgroundColor: 'white',
    textAlign: 'center',
    boxShadow: '0 5px 5px -5px #666'
  },
  inputStyle: {
    borderRadius: '25px',
    border: '1px solid grey',
    height: '40px',
    width: '100%',
    paddingLeft: '2em',
    paddingRight: '2em',
    outline: 'none',
    fontSize: '0.8em'
  },
  liCenterStyle: {
    display: 'inline-block',
    fontSize: '0.9em',
    margin: '0.8em',
    width: '40%'
  },
  linkStyle: {
    textDecoration: 'none',
    color: 'grey'
  },
  linkStyleHover: {
    textDecoration: 'none',
    color: 'grey',
    cursor: 'pointer'
  },
  liLeftStyle: {
    float: 'left'
  },
  liRightStyle: {
    float: 'right',
    fontSize: '0.7em',
    marginTop: '1.7em',
    marginRight: '1.7em',
  },
  brandContentStyle: {
    float: 'left',
    marginTop: '0.9em'
  },
  brandImgStyle: {
    float: 'left',
    margin: '10px 20px 10px 20px'
  },
  // wrapperStyle: {
  //   // boxShadow: '0 4px 2px -2px lightgrey',
  //   boxShadow: '0 5px 5px rgba(182, 0, 182, 0.75)'
  // }
  // FOR THE TERM 'BETA' NEXT TO BRAND NAME 'ENVELOPE'
  // smallStyle: {
  //   fontSize: '0.6em',
  //   color: '#aaa',
  //   float: 'left',
  //   paddingTop: '1.4em',
  //   paddingLeft: '0.4em',
  // }
}

// liCenterStyle: {
//   display: 'inline-block',
//   fontSize: '0.9em',
//   margin: '0.8em',
//   width: '40%'
// },

// const SearchBox = styled.div`
//   display: inline-block;
//   font-size: 0.9em;
//   margin: 0.8em;
//   width: 40%;
//   @media (max-device-width: 1224px) {
//     width: 0;
//   }
// `


class NavBar extends Component {
  constructor() {
    super()
    this.state = {
      hovered: "",
      searchString: "",
      logInhovered: false
    }
  }
  componentWillMount = () => {
     this.handleSearchDebounced = debounce(function () {
         this.props.handleSearch.apply(this, [this.state.searchString]);
     }, 500);
  }
  componentWillReceiveProps(nextProps) {
    // console.log('NEXT PROPS', nextProps);
    if (nextProps.searchString === '') {
      this.setState({ searchString: '' });
    }
  }
  onSearchChange = (e) => {
    this.setState({searchString: e.target.value});
    this.handleSearchDebounced();
  }
  render() {
    const { ulStyle, liLeftStyle, liRightStyle, liCenterStyle, inputStyle,
            brandContentStyle, brandImgStyle, linkStyle, linkStyleHover
           } = styles;
    return (
      <div>
        <ul style={ulStyle}>
          <Link
            onClick={this.props.clearSearchString}
            to='/'
            style={linkStyle}
          >
            <li style={liLeftStyle}>
                  <img style={brandImgStyle} src="/envelopeLogoRed.png" alt="" height="50"></img>
                <MediaQuery query="(min-device-width: 1224px)">
                  <div style={brandContentStyle} >Envelope</div>
                </MediaQuery>
              {/* <div style={smallStyle}>BETA</div> */}
            </li>
          </Link>
          <MediaQuery query="(min-device-width: 1224px)">
          <li style={liCenterStyle}>
              <input
                value={this.state.searchString}
                style={inputStyle}
                onChange={this.onSearchChange}
                placeholder='Search...'
                onFocus={(e) => e.target.placeholder = '' }
                onBlur={(e) => e.target.placeholder = 'Search...' }
              />
          </li>
        </MediaQuery>

          {this.props.user ? (
             <li style={liRightStyle}>
              <a
                onMouseEnter={() => this.setState({ logInhovered: true})}
                onMouseLeave={() => this.setState({ logInhovered: false})}
                style={this.state.logInhovered ? linkStyleHover : linkStyle}
                onClick={this.props.logOut}
              >Log Out
              </a>
            </li>
          ) : localStorage.getItem("hasLoggedIn") ? (
            <li style={liRightStyle}>
             <a
               onMouseEnter={() => this.setState({ logInhovered: true})}
               onMouseLeave={() => this.setState({ logInhovered: false})}
               style={this.state.logInhovered ? linkStyleHover : linkStyle}
               onClick={this.props.logIn}
             >Log In
             </a>
           </li>
          ) : (
            <li style={liRightStyle}>
             <a
               onMouseEnter={() => this.setState({ logInhovered: true})}
               onMouseLeave={() => this.setState({ logInhovered: false})}
               style={this.state.logInhovered ? linkStyleHover : linkStyle}
               onClick={this.props.signUp}
             >Sign Up
             </a>
           </li>
          )
        //   <li style={liRightStyle}>
        //    <a
        //      onMouseEnter={() => this.setState({ logInhovered: true})}
        //      onMouseLeave={() => this.setState({ logInhovered: false})}
        //      style={this.state.logInhovered ? linkStyleHover : linkStyle}
        //      onClick={this.props.signIn}
        //    >Log In
        //    </a>
        //  </li>
         }

         <MediaQuery query="(min-device-width: 1224px)">
          <li style={liRightStyle}>
            <Link style={linkStyle} to="/myenvelopes">My Envelopes</Link>
          </li>
        </MediaQuery>
        <MediaQuery query="(max-device-width: 1224px)">
         <li style={liRightStyle}>
           <Link style={linkStyle} to="/myenvelopes">My</Link>
         </li>
       </MediaQuery>
          <li style={liRightStyle}>
            <Link style={linkStyle} to="/about">About</Link>
          </li>
          <MediaQuery query="(min-device-width: 1224px)">
            <li style={liRightStyle}>
              <Link style={linkStyle} to="/new">Create</Link>
            </li>
          </MediaQuery>
        </ul>
      </div>
    );
  }
}



export default NavBar;



// WEBPACK FOOTER //
// ./src/_NavBar.js